{
  "slug": "iq-vs-intelligence",
  "title": "智商与智力:他们是相同的吗?",
  "description": "了解标准化的智商分数和更广泛的人类智力概念之间的区别。",
  "summary": "智商是一个广泛的心理学概念,是基于选定认知任务的表现的标准化估计。",
  "sections": [
    {
      "heading": "智能不仅仅是一个分数",
      "paragraphs": [
        "心理学家用智力来讨论学习、推理、解决问题、适应和使用知识的能力,但理论有所不同:有些强调一个一般因素,而其他人则描述了多种广泛或专门的能力。",
        "智能在真实环境中运作,实用知识、创造力、坚持不懈和文化经验决定了人们如何解决有意义的问题。"
      ]
    },
    {
      "heading": "智商是一种测量工具",
      "paragraphs": [
        "智商分数总结了相对于基于年龄的规范群体的认知表现样本。设计良好的测试可以预测某些教育和职业结果，但预测是统计的，而不是命运。",
        "任务、评分、规范、语言和测试条件都会决定一个结果能够支持什么,而不是只能通过测试来确定一个结果是否支持某种特定的智能行为。"
      ]
    },
    {
      "heading": "使用正确的水平的分数",
      "paragraphs": [
        "当问题与证据相符时，智商是有用的，比如在综合评估中描述认知优势和需求的模式，而当作为天赋、性格、创造力或价值观的缩写时则不那么有用。",
        "仔细的解读将分数与历史、行为、环境、目标和其他相关信息结合起来。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "IQ是否衡量所有的智力?",
      "answer": "不,它取样重要的认知能力,但并不耗尽创造力,实际判断,智慧,动机,或情绪技巧。"
    },
    {
      "question": "一个人能够有一个平均的智商是聪明的吗?",
      "answer": "是的,平均复合能力可以与特定的优势、专业知识、创造力或有效的实际解决问题能力共存。"
    }
  ],
  "related": ["what-is-iq", "iq-vs-eq", "how-is-iq-measured"]
}
